var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 58,
    viewBox: "0 0 80 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4286 0.428345H8.57142C3.83755 0.428345 0 4.2659 0 8.99977V48.9997C0 53.7336 3.83755 57.5711 8.57142 57.5711H71.4286C76.1624 57.5711 80 53.7336 80 48.9997V8.99977C80 4.2659 76.1624 0.428345 71.4286 0.428345ZM74.2856 33.5311L56.3057 15.5512C55.1901 14.4358 53.3814 14.4358 52.2658 15.5512L28.5715 39.2453L19.1628 29.8367C18.0472 28.7212 16.2385 28.7212 15.1229 29.8367L5.71423 39.2453V8.99977C5.71423 7.42176 6.99341 6.14257 8.57142 6.14257H71.4286C73.0066 6.14257 74.2858 7.42176 74.2858 8.99977V33.5311H74.2856Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImg);
export default __webpack_public_path__ + "static/media/emptyImg.73e3ceb4e658d16bc42daf87a7d51cdd.svg";
export { ForwardRef as ReactComponent };